<template>
  <div>
    <div class="banner innerpageBanner"><div class="container"><div class="caption"><div><h1>最新活动</h1> <p>大师班课程及主题品鉴</p></div></div></div> <img src="https://image.insideburgundy.cn/insideburgundy/20190523/958212f208d6451d880790f9a003323c.png" alt="最新活动" class="cover-image"></div>

    <div class="container">
      <searchBox  />
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
          <span property="itemListElement" typeof="ListItem">
              <span property="name">最新活动</span>
              <meta property="position" content="2">
            </span>
        </div>
      </div>
    </div>

    <div class="container">
      <p>&nbsp;</p>
      <!--<h3 style="padding-bottom: 20px;">最新活动</h3>-->
      <ul class="activity newsListing">
        <li class="activity-one " v-for="item in activity" :key='item.id'>
          <div class="activityLeft">
            <img :src="item.image" alt="">
          </div>
          <div class="activityRight">
            <div
                class="post-28874 post type-post status-publish format-standard has-post-thumbnail hentry category-just-jasper category-inside-burgundy"
              >
                <h4>
                  <a @click="getdetail(item.id)" style="cursor:pointer;overflow:hidden;text-overflow:ellpsis;white-space:nowrap">{{item.title}}</a>
                  <span>{{item.createTime}}</span>
                </h4>

                <div class="entry">
                  <p>{{item.introduction}}</p>
                </div>

                <div style="position:absolute;bottom:28px">
                  <a @click="getdetail(item.id)"   style="cursor:pointer">详细信息</a>
                </div>
              </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import searchBox from '../template/search';
import ajax from '../ajax'
export default {
  data(){
    return {
      activity:[]
    }
  },
  components:{
    searchBox
  },
  created() {
    this.showlist()
  },
  methods: {
    getdetail(id){
      console.log(id)
      this.$router.push({path:'/eventdetails',query:{id}})
    },
    showlist(){
      ajax.getactivity().then(res=>{
        this.activity = res.data.data
      })
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },

    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Theactivity.vue